<template>
  <div>
    <div class="head-box">
      <h4>采购订单</h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="编号/收货人/电话/地址"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <!-- <el-button
          v-if="osg.has('PurchaseOrders,new')"
          type="primary"
          @click="doNew"
          class="c-m-l-10"
        >
          新增采购单
        </el-button> -->
        <el-button
          v-if="osg.has('PurchaseOrders,export')"
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'regex:name|string#or': searchValue,
                'regex:code|string#or': searchValue,
                'in:state|array-integer#and': '0,1',
                sortField: 'order,_id',
                sortOrder: 'asc',
                beanName: 'purchaseOrder',
                title: '采购订单'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <!-- @selection-change="selectRows" -->
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <!-- <el-table-column type="selection" width="55" fixed></el-table-column> -->
          <!-- 动态列 -->
          <c-table :fields="extFields">
            <template slot="productList">
              <el-table-column
                label="选择产品"
                width="100px"
                prop="productList"
                show-overflow-tooltip
              >
                <!-- :formatter="formatProductList" -->
                <!-- <template slot-scope="scope">
                  {{ formatProductList(scope.row.sendDistricts) }}
                </template> -->
              </el-table-column>
            </template>
          </c-table>
          <!-- table                v-if="
              osg.has('Materials,edit') ||
                osg.has('Materials,enable') ||
                osg.has('Materials,remove')
            " -->
          <el-table-column fixed="right" width="110" label="操作">
            <template slot-scope="scope">
              <el-dropdown class="c-m-l-10">
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- v-if="osg.has('Materials,edit')" -->
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="openDetails(scope.row)">
                    查看订单明细
                  </el-dropdown-item>
                  <!-- <template v-if="osg.has('Materials,enable')">
                    <el-dropdown-item
                      v-if="scope.row.state == 1"
                      @click.native="doDisable(scope.row._id)"
                    >
                      禁用
                    </el-dropdown-item>
                    <el-dropdown-item v-else @click.native="doEnable(scope.row._id)">
                      启用
                    </el-dropdown-item>
                  </template> -->
                  <!-- <el-dropdown-item
                    v-if="osg.has('Materials,remove')"
                    @click.native="doRemove(scope.row._id)"
                  >
                    删除
                  </el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="采购订单" :close-on-click-modal="false" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        @changeForm="osg.changeForm"
      >
        <!-- partnerId -->
        <template slot="partnerId">
          <el-select v-model="formData.partnerId" placeholder="请选择供应商" filterable>
            <el-option
              v-for="item in supplierData"
              :key="item.value"
              :label="item.orgName"
              :value="item._id"
            ></el-option>
          </el-select>
        </template>
        <template slot="productList">
          <el-button @click="openProductDetail">选择产品</el-button>
          <el-table :data="product.productList" border class="c-m-t-10">
            <!-- :formatter="formatProductData" -->
            <el-table-column prop="name" label="产品名称" width="200"></el-table-column>
            <el-table-column prop="exts.count" label="产品数量" width="200"></el-table-column>
            <el-table-column fixed="right" width="100px" label="操作">
              <template slot-scope="scope">
                <el-button @click.native="scope.index;" size="mini">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave()">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 选择产品弹窗 -->
    <el-dialog
      title="选择产品"
      custom-class="c-dialog c-min-height-80vh"
      :visible.sync="productDetail"
      :close-on-click-modal="false"
      @close="cancelProduct"
    >
      <div class="c-flex c-flex-between c-flex-item">
        <el-input
          class="search-input c-fr"
          placeholder="请输入产品名称"
          v-model="product.searchValue"
          clearable
          @clear="
            selectProduct();
            product.notAddedFpi.page = 1;
            getProduct();
          "
          @keyup.enter.native="
            selectProduct();
            product.notAddedFpi.page = 1;
            getProduct();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              selectProduct();
              product.notAddedFpi.page = 1;
              getProduct();
            "
          ></el-button>
        </el-input>
      </div>
      <el-table
        ref="notAddedTable"
        empty-text="没有查询到产品"
        @selection-change="selectProduct"
        :data="product.productData"
        :row-key="getRowKey"
      >
        <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
        <el-table-column prop="name" label="产品名称"></el-table-column>
        <el-table-column prop="code" label="产品编号"></el-table-column>
        <el-table-column prop="unit" :formatter="formatUnit" label="产品单位"></el-table-column>
        <el-table-column
          prop="productType"
          :formatter="formatProductType"
          label="产品类型"
        ></el-table-column>
        <el-table-column
          prop="exts.productProperty"
          :formatter="formatProductProperty"
          label="产品属性"
        ></el-table-column>
        <el-table-column
          prop="exts.agelimit"
          :formatter="formatAgelimit"
          label="最高质保年限"
        ></el-table-column>
        <el-table-column
          prop="exts.repairParts"
          :formatter="formatRepairPart"
          label="维修部位"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="产品数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.exts.count" placeholder="请输入数量"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-pagination
          class="pagination"
          @size-change="pageSizeChangeProduct"
          @current-change="pageChangeProduct"
          :current-page="product.notAddedFpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="product.notAddedFpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="product.notAddedFpi.total"
        ></el-pagination>
        <el-button type="primary" @click="addproduct()">确 定</el-button>
        <el-button @click="cancelProduct">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 查看订单明细 -->
    <el-dialog
      title="订单明细"
      :close-on-click-modal="false"
      :visible.sync="orderDetails.show"
      width="1100px"
    >
      <el-table
        ref="orderDetailsForm"
        :data="orderDetails.data"
        highlight-current-row
        border
        style="margin-bottom:50px;"
        class="c-table-border"
      >
        <c-table :fields="extFields"></c-table>
      </el-table>
      <el-table
        v-if="orderDetails.data[0]"
        ref="orderDetails"
        :data="orderDetails.data[0].materialList"
        highlight-current-row
        border
        class="c-table-border"
      >
        <el-table-column prop="exts.count" label="数量" fixed></el-table-column>
        <c-table :fields="materialFields">
          <template slot="classifyId">
            <el-table-column
              prop="classifyId"
              label="商品分类"
              :formatter="formatClassify"
            ></el-table-column>
          </template>
        </c-table>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'PurchaseOrders',
  data() {
    window.$this = this;
    return {
      type: '',
      tenantId: '',
      loginOrgId: '',
      name: 'purchaseOrder',
      refresh: true,
      fpi: {},
      selectedRows: [],
      searchValue: '',
      openDetail: false,
      productDetail: false,
      formData: {
        address: '',
        exts: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_unit: { codeId: 'UNIT' },
        codecfg_productData: { codeId: 'productData' },
        codecfg_productType: { codeId: 'productType' },
        codecfg_productProperty: { codeId: 'productProperty' },
        codecfg_agelimit: { codeId: 'agelimit' },
        cascadeCode_repairParts: { codeId: 'repairParts' },
        allClassify: []
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        // downloadUrl: this.osg.downloadUrl,
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        // 新增
        limit: 10
      },
      product: {
        searchValue: '',
        exts: {
          count: ''
        },
        productList: [], //勾选中的产品
        productData: [], //查出的产品
        selectedRows: [],
        notAddedFpi: {
          data: []
        }
      },

      supplierData: [], //服务商
      dataList: [],
      materialFields: [],
      orderDetails: {
        show: false,
        data: []
      }
    };
  },
  mounted() {
    // 当前用户tenantId
    let account = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = account.tenantId;
    this.loginOrgId = account.orgId;

    this.doInit();
    this.osg.getFields('purchaseOrder', () => {
      this.osg.getFpi();
      this.getData();
    });
    this.osg.getFields('material', () => {}, null, 'materialFields');
    this.getAllClassify();
  },
  methods: {
    // formatProductData(cellValue) {
    //   for (var i = 0; i < this.product.productData.length; i++) {
    //     if (cellValue.productId == this.product.productData[i]._id) return this.productData[i].name;
    //   }
    //   // return this.osg.codelabel('productData', cellValue);
    // },    productType
    // 单位
    // formatProductList(row) {
    //   debugger;
    //   if (row) {
    //     var opts = window.$this.options[row] || window.$this.options[row.toLowerCase()]; // 避免有些字典表codeType是大写,预置没有
    //   }
    //   if (opts && row) {
    //     for (let i = 0; i < this.product.productData; i++) {
    //       if (opts[i].value.indexOf(row) != -1) {
    //         return opts[i].name;
    //       }
    //     }
    //   }
    //   if (!row) {
    //     return row;
    //   } else {
    //     return '未知';
    //   }
    // },
    formatUnit(row, column, cellValue) {
      return this.osg.codelabel('unit', cellValue);
    },
    // 产品类型
    formatProductType(row, column, cellValue) {
      return this.osg.codelabel('productType', cellValue);
    },
    // 产品属性
    formatProductProperty(row, column, cellValue) {
      return this.osg.codelabel('productProperty', cellValue);
    },
    // 最高质保年限
    formatAgelimit(row, column, cellValue) {
      return this.osg.codelabel('agelimit', cellValue);
    },
    // 维修部位
    formatRepairPart(row, column, cellValue) {
      return this.osg.formatCascadeMultiple('repairParts', cellValue);
    },
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    formatCascade(option, arr) {
      let str = '';
      let opts = this.$util.deepCopy(this.options[option]);
      // 单选级联 有几级循环几次
      for (var i = 0; i < arr.length; i++) {
        for (var opt of opts) {
          if (opt.value == arr[i]) {
            str += (opt.label || opt.name) + '、';
            opts = this.$util.deepCopy(opt.children);
            break;
          }
        }
      }
      return str.slice(0, str.length - 1);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      //
      if (this.$refs['formData']) {
        this.$refs['formData'].resetFields();
      }
      this.upload.data = {};
      this.formData = { images: [], exts: {}, address: '' };
      this.$util.renderExtField(this.extFields, this.formData);
      this.product.productList = [];
    },

    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'is:_id|string#or': this.searchValue,
        'regex:purchaseName|string#or': this.searchValue,
        'regex:purchasePhone|string#or': this.searchValue,
        'regex:purchaseAdress|string#or': this.searchValue,
        // 'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/purchaseOrder/query.do', params, res => {
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        // 赋值
        this.fpi = res;
        this.dataList = res.data;
        console.log(this.fpi, 'this.fpi');
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
          // this.getProduct();
          // this.getSupplier();
        });
      });
    },
    // 获取产品
    getProduct() {
      let params = {
        page: this.product.notAddedFpi.page,
        rows: this.product.notAddedFpi.rows,
        'regex:name|string#or': this.product.searchValue,
        // 'regex:code|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      // if (this.tenantId != '1340835581184723420') {
      //   if (this.type == '3') {
      //     params['is:productType|string#and'] = '3';
      //   } else if (this.tenantId != '4551453470943235290') {
      //     params['in:productType|array#and'] = '1,2';
      //   }
      // }
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/product/query.do', params, res => {
        res.data.map(item => {
          if (this.$util.isJson(item.productBizType))
            item.productBizType = JSON.parse(item.productBizType);
        });
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        this.product.productData = res.data;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    // 获取供应商
    getSupplier() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:_id|string#or': this.searchValue,
        // 'in:state|array-integer#and': this.state == 'archived' ? -1 : '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      // if (this.type == 'all') {
      //   params['ne:tenantId|string#and'] = '1340835581184723420';
      // }
      //添加过滤器参数
      // $that.getParams(params);
      // this.osg.setFpi(params);
      this.osg.ajax(
        // this.type == 'all' ? 'basic/partner/queryAll.do' : 'basic/partner/query.do',
        'basic/supplier/query.do',
        params,
        res => {
          this.supplierData = res.data;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
            this.$forceUpdate();
          });
          // this.getOrg();
        }
      );
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      //
      row = Object.assign({}, row); //避免编辑内容后取消导致显示异常
      this.$util.renderExtField(this.extFields, row);
      // 解析图片字段
      if (row.images) {
        if (this.$util.isJson(row.images)) {
          row.images = JSON.parse(row.images);
        }
      } else {
        row.images = [];
      }
      // this.formData = row;
      this.formData = this.$util.deepCopy(row);
      this.product.productList = this.formData.productList;
      this.openDetail = true;
    },
    doSave() {
      this.formData.productList = this.product.productList;
      console.log(this.productList, '----this.productList');
      let params = this.$util.deepCopy(this.formData);
      // params.approveState = 0; //修改数据时审核状态改为0

      // 超级管理员、平台管理员、当前组织都可以看到此条数据
      // params.scopeJson = params.scopeJson || [];
      // params.scopeIds = params.scopeIds || [];
      // if (params.scopeIds.indexOf('0') == -1) params.scopeIds.push('0');
      // if (params.scopeIds.indexOf(this.tenantId) == -1) params.scopeIds.push(this.tenantId);
      // if (params.scopeIds.indexOf(this.loginOrgId) == -1) params.scopeIds.push(this.loginOrgId);

      // this.$util.saveExtField(this.extFields, row);
      this.$util.saveExtField(this.extFields, params);
      if (this.osg.validate()) {
        params.images = params.images || [];
        params.images.map(item => {
          if (item.url.indexOf('blob:') != -1) {
            item.url = this.upload.downloadUrl + item.response.key;
          }
        });
        params.images = JSON.stringify(params.images);

        this.osg.ajax('basic/purchaseOrder/upsert.do', { data: JSON.stringify(params) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
        this.product.productList = [];
      }
    },
    // 列表多选
    // selectRows(rows) {
    //   this.selectedRows = rows;
    // },
    openProductDetail() {
      this.getProduct();
      this.product.selectedRows = [];
      this.productDetail = true;
    },
    // 添加产品
    addproduct() {
      if (this.product.selectedRows.length == 0) {
        this.osg.toast('请选择至少1项！', 'warning');
        return;
      }
      this.product.productList = this.product.selectedRows;
      console.log(this.product.productList, '---this.productList');
      this.productDetail = false;
    },
    // 取消添加产品
    cancelProduct() {
      this.product.searchValue = '';
      this.selectProduct();
    },
    //删除条件
    removeCondition(index) {
      this.product.productList.splice(index, 1);
    },
    // 选择产品
    selectProduct(rows) {
      this.product.selectedRows = rows || [];
      console.log(this.product.selectedRows, 'this.product.selectedRows');
    },
    getRowKey(row) {
      return row._id;
    },
    pageSizeChangeProduct(pageSize) {
      if (this.product.open) {
        this.product.notAddedFpi.rows = pageSize;
        this.getProduct();
      }
    },
    pageChangeProduct(currentPage) {
      if (this.product.open) {
        this.product.notAddedFpi.page = currentPage;
        this.getProduct();
      }
    },
    openDetails(data) {
      this.orderDetails.data = [data];
      this.orderDetails.show = true;
      this.$nextTick(() => {
        this.$refs.orderDetails.doLayout();
        this.$forceUpdate();
      });
    },
    getAllClassify() {
      this.osg.ajax('/biz/classify/queryWithSmooth.do', {}, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.allClassify = res.data;
      });
    },
    formatClassify(row, column, cellValue) {
      return this.osg.codelabel('allClassify', cellValue);
    }
  }
};
</script>
<style lang="scss">
.c-dialog {
  min-width: 1000px !important;
}
</style>
